import { render, staticRenderFns } from "./BtnDelete.vue?vue&type=template&id=32e52c02&"
import script from "./BtnDelete.vue?vue&type=script&lang=js&"
export * from "./BtnDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BtnDelete.vue"
export default component.exports